import checkStatus from '../../../utils/checkStatus.js';
import { repairAllProducts, checkIfUpdatesExist } from '../../../utils/mass-rate-change-helpers';
import R from 'ramda';

const credentialsAndHeaders = {
  credentials: 'same-origin',
  headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
};

const put = body => Object.assign({ method: 'put', body: JSON.stringify(body) }, credentialsAndHeaders);

export function getMassRateChangeData({ contractId }) {
  return dispatch => {
    dispatch({ type: 'GETTING_MASS_RATE_CHANGE_DATA' });
    return fetch(`/proxy/contracting/massRateChange/${contractId}`, {
      method: 'get',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    })
    .then(checkStatus)
    .then(res => res.json())
    .then(({ locationId, ...allKindsOfRates }) => dispatch({ type: 'GOT_MASS_RATE_CHANGE_DATA', payload: { thisUpdateType: 'extras', allKindsOfRates, locationId } }))
    .catch((err) => {
      console.log(err.stack);
      dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Failed to get rates' });
    });
  };
}
// allKindsOfRatesInSchemaFormat = [{
//  updateType,
//  productUpdates,
// }]
export function massRateChange(contractId, allKindsOfRatesInSchemaFormat, allUpdated) {
  return dispatch => {
    dispatch({ type: 'SAVING_MASS_RATE_CHANGE_DATA' });
    return fetch(`/proxy/contracting/massRateChange/${contractId}`, put({ allKindsOfRatesInSchemaFormat }))
      .then(checkStatus)
      .then(res => res.json())
      .then(response => dispatch({ type: 'SAVED_MASS_RATE_CHANGE_DATA', payload: { allKindsOfRates: response, allUpdated } }))
      .catch(err => dispatch({ type: 'SHOW_CONTRACTING_ERROR_STRING', payload: 'Mass Rate Change Failed' }));
  };
}




// WEBPACK FOOTER //
// ./src/app/stores/contracting/mass-rate-change/mass-rate-change-actions.js